import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"
import { Link } from "gatsby"

import { Icon } from "../Icon/Icon"
import { AccordionAnimation } from "./AccordionAnimation"
import { withAccordion } from "./withAccordion"
import { styles as textStyles } from "../Styled/Text"

const styles = {
  border: {
    header: tw`border-b border-dark`,
    headerNested: tw``,
    footer: tw`border-b border-grey px-2-4`,
    account: tw`border-t border-dark`,
    accountMobile: tw`border-t border-dark`,
    filter: tw`border-b border-grey`,
    product: tw``,
    upsell: tw``,
    blog: tw``,
    menu: tw``,
  },
  layout: {
    header: tw`h-4-8 justify-between`,
    headerNested: tw`h-4-8 justify-start uppercase`,
    footer: tw`h-8 justify-between`,
    account: tw`h-7 justify-start`,
    accountMobile: tw`h-auto pt-2-4 justify-start`,
    filter: tw`h-6-7 justify-between items-center`,
    product: tw`h-3-4 justify-between items-center uppercase font-bold w-full border-t border-dark`, //h-4-8
    upsell: tw`h-3-4 justify-between items-center uppercase font-bold w-full px-2-4`, //h-4-8
    blog: tw`h-4-8 justify-start`,
    menu: tw`mb-1-6`,
    filterOption: tw`justify-start uppercase`,
  },
  size: {
    header: textStyles.H1,
    headerNested: tw`text-14`, //textStyles.H3,
    footer: textStyles.H1,
    account: textStyles.P,
    accountMobile: "",
    filter: textStyles.H3,
    // product: textStyles.Small,
    product: tw`font-display text-10 tracking-wide leading-1.43 md:text-14 md:tracking-wider md:leading-1.11`,
    upsell: tw`font-rodgerbold text-16`,
    blog: textStyles.P,
    menu: tw`text-32 font-body md:tracking-relaxed md:leading-1.14 inline`,
  },
}

const Wrapper = styled.div<WrapperProps>`
  ${tw`relative w-full text-dark`}
  ${({ size, noBorder }) => (size && !noBorder ? styles.border[size] : null)}
  ${({ size }) => (size === "upsell" ? tw`py-1-4` : null)}
`
const TitleWrapper = styled.button<TitleWrapperProps>`
  ${tw`w-full flex items-center justify-between focus:outline-none`}
  ${({ size }) => (size ? styles.layout[size] : null)}
`
// const Title = styled(StyledH3)<TitleProps>`
//   ${({ rightSpace }) => (rightSpace ? tw`pr-1` : null)}
//   ${({ size }) => (size ? styles.size[size] : null)}
//   ${({ size }) => (size === "product" ? tw`tracking-wider` : null)}
// `
const Title = styled.div<TitleProps>`
  ${({ rightSpace }) => (rightSpace ? tw`pr-1` : null)}
  ${({ size }) => (size ? styles.size[size] : null)}
  ${({ size }) => (size === "product" ? tw`tracking-wider` : null)}
`
const MenuTitle = styled.div<TitleProps>`
  ${({ rightSpace }) => (rightSpace ? tw`pr-1` : null)}
  ${({ size }) => (size ? styles.size[size] : null)}
  ${({ title }) => (title ? tw`text-lightRed` : null)}
`
// const MenuTitle = styled(StyledH5)<TitleProps>`
//   ${({ rightSpace }) => (rightSpace ? tw`pr-1` : null)}
//   ${({ size }) => (size ? styles.size[size] : null)}
//   ${({ title }) => (title ? tw`text-lightRed` : null)}
// `
const List = styled.ul<ListProps>`
  ${({ size }) => (size === `account` ? tw`pb-4` : null)}
`
const StyledSpan = tw.span`text-12`

export const Accordion = withAccordion(
  ({
    active = false,
    title = "",
    titleElement = null,
    children = null,
    size = null,
    link = null,
    icon = null,
    onClick = null,
    handleActive = null,
    handleRedirect = null,
    noBorder = false,
    subDigit = null,
  }): JSX.Element => {
    return (
      <Wrapper size={size} noBorder={noBorder} onClick={onClick}>
        {
          <TitleWrapper size={size} onClick={handleActive}>
            {titleElement ? (
              titleElement(active)
            ) : size === `product` || size === `blog` ? (
              <>
                <Title className="title_small" size={size} rightSpace>
                  {title}
                </Title>
                <Title className="title_small" size={size}>{`${active ? `-` : `+`}`}</Title>
              </>
            ) : size === `menu` ? (
              <>
                <MenuTitle size={size} to={link} as={link ? Link : null} rightSpace title={title === "Sale" ? "true" : null} className="menu_level_1">
                  {title} {/*subDigit ? <StyledSpan>({subDigit})</StyledSpan> : null */}
                </MenuTitle>
              </>
            ) : size === `upsell` ? (
              <>
                <Title className="dprimary_button" size={size} rightSpace>
                  {title}
                </Title>
                <Title className="dprimary_button" size={size}>{`${active ? `-` : `+`}`}</Title>
              </>
            ) : icon ? (
              <>
                <Title size={size} rightSpace className="title_small">
                  {title}
                </Title>
                {!active ? <Icon name={`plus`} size={10} /> : <Icon name={`cross`} size={10} />}
              </>
            ) : (
              <Title as={Link} size={size} to={link} onClick={handleRedirect} aria-label={title} className="title_small">
                {/* <h3>{title}</h3> */}
                {title}
              </Title>
            )}
          </TitleWrapper>
        }

        <AccordionAnimation active={active}>
          <List size={size}>{children}</List>
        </AccordionAnimation>
      </Wrapper>
    )
  }
)

type WrapperProps = {
  size: "header" | "headerNested" | "account" | "accountMobile" | "filter" | "product" | "upsell" | "blog" | "menu" | "filterOption"
  noBorder: boolean
}

type TitleWrapperProps = {
  size: "header" | "headerNested" | "account" | "accountMobile" | "filter" | "product" | "upsell" | "blog" | "menu" | "filterOption"
}

type TitleProps = {
  size: "header" | "headerNested" | "account" | "accountMobile" | "filter" | "product" | "upsell" | "blog" | "menu" | "filterOption"
  rightSpace?: boolean | undefined
}

type ListProps = {
  size: "header" | "headerNested" | "account" | "accountMobile" | "filter" | "product" | "upsell" | "blog" | "menu" | "filterOption"
}
